import React from 'react';

function TableHeaderCell({content, classes}) {
    return <th
        className={`sl-font sl-font-medium sl-text-sm sl-text-center sl-text-gray-700 sl-py-12 sl-px-16 sl-px-2 ${classes}`}>{content}</th>
}

export default TableHeaderCell;
